export default __webpack_public_path__ + "static/media/ic-instagram.eab16b05.svg";